import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, FormGroup, Checkbox, ControlLabel, FormControl, Button} from 'react-bootstrap';
import {getUser} from 'reducers/reducer_admin_users';
import ReactDOM from 'react-dom';
import config from  '../../../config';
import {makeRequest, dispatchAction, displayMessage}  from 'actions';
import {FETCH_USER, UPDATE_USER_DATA, UPDATE_USER, ADD_USER} from "actions/actionTypes";
import Select   from 'react-select'
import {prepareSelectOptionsList, validateEmail}  from 'util/Utils';
var locationsList =  _.map(config.warehouseData, function (item, key) {
    return {value: key, label: _.startCase(key)}
});
class AdminUserAddEdit extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            newRecord: this.props.location.pathname.includes('/user/add') ? true : false,
            userRoleVisible: false,

            currentUser: {},
        }
        this.addRecord = this.addRecord.bind(this);
        this.editRecord = this.editRecord.bind(this);
    }

    componentWillMount() {
        if (!this.state.newRecord ) {
            var methodData = {
                "success_event": FETCH_USER,
                'endpoint': '/users/' + encodeURIComponent(this.props.params.id),
                'not_display_success_message': true,
            };

            this.props.makeRequest({}, methodData).then(res => {
                console.log('res', res.data);
                this.setState({
                    currentUser: {
                        ...res.data,
                        UserRolesToDisplay:_.map(_.get(res.data,'Roles',[]),role=>{
                            return {value:role, label:role}
                        }),
                        ResourceAccessRights: _.reject(_.map(_.get(res.data, 'ResourceAccessRights', []), resource=> {
                             return {
                                value: resource,
                                label:  config.rolesToResourcesAccessMap[resource] ? _.get(config.rolesToResourcesAccessMap[resource], 'resourceLabel', _.startCase(resource)) : 'n/a'
                            }
                        }), {label: 'n/a'})
                    },
                    MarketName:_.find(locationsList, {'value': _.get(res.data, ['MarketName'], '')}),

                })
            });
        }
    }

    addRecord(e) {
        this.setState({pending: true})
        var self = this;
        e.preventDefault();
        var objectData = this.prepareData();
        if (!objectData) {
            return
        }
        var methodData = {
            type: 'post',
            endpoint: '/users',
            messageData: {'#1#': 'User'},
            messageCode: 'recordAdded'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            self.props.dispatchAction(response.data.User, ADD_USER)
            self.setState({pending: false})
            self.context.router.push(`/admin/users`)
        }).catch(function (e) {
            self.setState({pending: false})
        })
    }

    editRecord(e) {
        this.setState({pending: true})
        var self = this;
        e.preventDefault();

        var objectData = this.prepareData();
        if (!objectData) {
            return
        }
        var methodData = {
            type: 'patch',
            endpoint: '/users/' + encodeURIComponent(this.props.userRecord._id),
            messageData: {'#1#': 'User'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            var updateUserData = response.data.User;
            updateUserData.SellerRecord = _.get(self.props.userRecord, 'SellerRecord')
            self.props.dispatchAction(updateUserData, UPDATE_USER)
            if (response.data.User._id == self.props.userReducer.user._id) { /* update currently logged in user */
                self.props.dispatchAction(response.data, UPDATE_USER_DATA)
            }
            self.setState({pending: false})
        }).catch(function (e) {
            self.setState({pending: false})
        })
    }

    prepareData(e) {

        var objectData = {};

        var self = this,error = false
        var fields = ['firstName', 'lastName', 'email'];


        _.forEach(fields, function (fieldName) {
            var updatedValue = ReactDOM.findDOMNode(self.refs[fieldName]).value
            if (self.state.newRecord || updatedValue !== self.props.userRecord[fieldName]) {
                objectData[fieldName] = updatedValue
            }

        });

        var messageData = {
            'messageType': 'warning',
            'messageCode': 'errorFieldRequired'
        }

        if (_.get(objectData, ['firstName'], 'not_updated') == '') {
            this.props.displayMessage(_.extend(messageData, {'messageData': {'#1#': 'First name'}}));
            return false;
        }
        if (_.get(objectData, ['email'], 'not_updated') == '') {
            this.props.displayMessage(_.extend(messageData, {'messageData': {'#1#': 'Email'}}));
            return false;
        }
        if (objectData['email'] && !validateEmail(objectData['email'])) {
            this.props.displayMessage(_.extend(messageData, {'messageCode': 'Email is not valid'}));
            return false;
        }
console.log('objectData', objectData  );
        // if (objectData['MetroArea'] == '') {
        //     this.props.displayMessage(_.extend(messageData, {'messageData': {'#1#': 'Metro area'}}));
        //     return false;
        // }
        var fields = [
             {name:'MarketName',path:['MarketName', 'value'], required:true}]
        _.forEach(fields, function (field) {
            if(_.get(self.state, (field.path ? field.path:[field.name]), '') !== ''){
                _.set(objectData, ( field.setPath ? field.setPath:[field.name]), _.get(self.state, field.path ? field.path:[field.name]))
            } else if(field.required){
                self.props.displayMessage(_.extend(messageData, field.messageCode ? {messageCode:field.messageCode}:{},{ 'messageData': {'#1#': _.startCase(field.name)}}))
                error = true;
                return false;
            }
        });
        console.log('objectData 2', objectData  );
        if (error){
            return false;
        }
        if (!this.state.newRecord && this.state.userRoleVisible) {
            var updatedRoles =_.map(this.state.currentUser.UserRolesToDisplay,'value')

            if (_.size(_.difference(updatedRoles, this.state.currentUser.Roles)) > 0 || _.size(_.difference(this.state.currentUser.Roles, updatedRoles)) > 0) {
                objectData['Roles'] =updatedRoles
            }

            if (_.size(_.get(this.state.currentUser, 'ResourceAccessRights', []))) {
                objectData.ResourceAccessRights = _.map(_.get(this.state.currentUser, 'ResourceAccessRights', []), item => {
                    return item.value
                })
            }
        }
        return objectData;

    }


    render() {
        console.log('this.state', this.state);
        var user = this.props.userRecord;

        return (
            <div >
                <h4 className="left0">
                    {user ? 'Edit user' : 'Add new user'}
                </h4>
                { this.state.newRecord || user ? (
                    <Form onSubmit={this.state.newRecord ? this.addRecord : this.editRecord}>
                        <FormGroup>
                            <ControlLabel>First name</ControlLabel>
                            <FormControl type="text" defaultValue={user ? user.firstName : '' }
                                         ref="firstName"
                                         placeholder="First name"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Last name</ControlLabel>
                            <FormControl type="text" defaultValue={user ? user.lastName : '' }
                                         ref="lastName"
                                         placeholder="Last name"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Email</ControlLabel>
                            <FormControl type="text" ref="email" defaultValue={user ? user.email : ''}
                                         placeholder="Email"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Market</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable={false}
                                selectedOptions
                                clearable={false}
                                placeholder="Market Name"
                                options={ locationsList}
                                onChange={(selectedOptions)=>{
                                    var data = {MarketName: selectedOptions}
                                    console.log('data', data  );
                                    if(_.get(data.MarketName,'value') && this.state.newRecord && !this.state.PickupAddressState){
                                        data.PickupAddressState =_.get(_.find(config.warehouseData, {MarketName: data.MarketName.value}), 'provinceCode')
                                    }
                                    this.setState(data)
                                }}
                                value={this.state.MarketName }
                            />

                        </FormGroup>

                        { !this.state.newRecord &&
                        <div>
                            <Checkbox
                                onClick={() => {

                                    this.setState({
                                        'userRoleVisible': !this.state.userRoleVisible
                                    })
                                }}
                                checked={this.state.userRoleVisible }>Change access rights</Checkbox>

                            <FormGroup>
                                <ControlLabel>User Roles</ControlLabel>
                                <Select
                                    placeholder="Roles"
                                    clearable={false}
                                    options={_.map(config.userRoles,role=>{
                                        return  {value:role, label:role}
                                    })}
                                    multi
                                    disabled={!this.state.userRoleVisible}
                                    onChange={(selectedOptions) => {


                                        var dataToUpdate ={
                                            ...this.state.currentUser,
                                            'UserRolesToDisplay': selectedOptions
                                        }
                                      //  console.log('selectedOptions.length', selectedOptions.length  );
                                     //   console.log('current', _.get(this.state.currentUser,'UserRolesToDisplay',[]).length  );
                                        if(selectedOptions.length > _.get(this.state.currentUser,'UserRolesToDisplay',[]).length) {
                                            console.log('role',  _.last(selectedOptions) );var ResourceAccessRightsToAdd =[]
                                            if (_.get(_.last(selectedOptions), 'value') == 'Administrator') {
                                                ResourceAccessRightsToAdd = [{
                                                    value: 'full_access',
                                                    label: config.rolesToResourcesAccessMap['full_access'].resourceLabel
                                                },
                                                    {
                                                        value: 'problem_solver_access',
                                                        label: config.rolesToResourcesAccessMap['problem_solver_access'].resourceLabel
                                                    },
                                                ]
                                            } else if (_.get(_.last(selectedOptions), 'value') == 'Wingmom') {
                                                ResourceAccessRightsToAdd = [{
                                                    value: 'processor_access',
                                                    label: config.rolesToResourcesAccessMap['processor_access'].resourceLabel
                                                }]
                                            }
                                            if (ResourceAccessRightsToAdd.length) {
                                                console.log('ResourceAccessRightsToAdd', ResourceAccessRightsToAdd);
                                                var ResourceAccessRights = _.uniqBy(_.concat(_.get(this.state.currentUser, 'ResourceAccessRights', []), ResourceAccessRightsToAdd), 'value')
                                                console.log('ResourceAccessRights ', ResourceAccessRights);
                                                dataToUpdate.ResourceAccessRights = ResourceAccessRights
                                            }
                                        }
                                        this.setState({
                                            currentUser:dataToUpdate
                                        })
                                    }}
                                    value={_.get(this.state.currentUser, ['UserRolesToDisplay'],  [])}
                                />

                            </FormGroup>


                            <FormGroup>
                                <Select
                                    disabled={!this.state.userRoleVisible}
                                    tabIndex="0"
                                    multi
                                    placeholder="Resource access rights"
                                    clearable={true}
                                    options={prepareSelectOptionsList(_.reject(_.map(config.rolesToResourcesAccessMap,( item,resource)=>{
                                        return {...item, resource:resource}
                                    }), item=>{
                                        return item.doNotDisplayInSelect
                                    }), {
                                        label:(item)=> {
                                                        return  _.get(item, 'resourceLabel',  _.startCase(item.resource))
                                        },
                                        value: 'resource'
                                    })}
                                    onChange={(selectedOptions) => {
                                        this.setState({
                                            currentUser: {
                                                ...this.state.currentUser,
                                                'ResourceAccessRights': selectedOptions
                                            }
                                        }, function () {

                                        });
                                    }}
                                    value={this.state.currentUser.ResourceAccessRights}
                                />
                            </FormGroup>

                        </div>
                        }

                        { !this.state.newRecord &&
                        <div>
                            <FormGroup>
                                <Button className="btn-primary"
                                        onClick={(event) => {
                                            this.context.router.push(`/admin/contractors/${encodeURIComponent(this.props.userRecord._id)}/add`)
                                        }
                                        }>
                                    Add Worker
                                </Button>

                            </FormGroup>
                        </div>
                        }
                        <FormGroup>
                            <Button className="btn-primary" disabled={this.state.pending} type="submit">
                                Save
                            </Button>
                        </FormGroup>
                    </Form>
                ) : ''}
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userRecord: getUser(state, props.params.id),
        userReducer: state.userReducer
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserAddEdit);
